/** @file Directions panel body: create a set, or edit its count/layout/iso, pick a direction, edit it. */
import { allowedDirs } from '@pose2d/commands/direction/allowedDirs';
import type { Dir } from '@pose2d/format/types';
import { useState } from 'react';
import { Button } from '../../ui-kit/Button';
import type { RigView } from '../rigKit/rigView';
import { Compass } from './Compass';
import { DirectionEditor } from './DirectionEditor';
import { SetControls } from './SetControls';

/** The selected direction falls back to the set's first direction when it leaves the set (count or layout change). */
export function DirectionsView({ doc, t, run }: RigView) {
  const [picked, setPicked] = useState<Dir | null>(null);
  const set = doc.directions;
  if (set === undefined) {
    const create = (count: 4 | 8): void => { run([{ name: 'direction.setCount', input: { count } }]); };
    return (
      <div className="rig-body">
        <p className="rig-hint">{t('panels.directions.none')}</p>
        <div className="rig-actions">
          <Button label={t('panels.directions.create4')} onClick={() => { create(4); }} />
          <Button label={t('panels.directions.create8')} onClick={() => { create(8); }} />
        </div>
      </div>
    );
  }
  const allowed = allowedDirs(set.count, set.layout4);
  const dir = picked !== null && allowed.includes(picked) ? picked : allowed[0];
  return (
    <div className="rig-body">
      <SetControls t={t} run={run} set={set} />
      <Compass t={t} set={set} selected={dir} onSelect={setPicked} />
      {dir !== undefined && <DirectionEditor doc={doc} t={t} run={run} set={set} dir={dir} />}
    </div>
  );
}
